import Swal from 'sweetalert2';
import warning from "@/assets/images/icon/mingcute--warning-line.png"

/**
 * Show a customizable confirmation alert with SweetAlert2.
 *
 * @param {string} title - The title of the alert.
 * @param {string} text - The text of the alert.
 * @param {string} confirmButtonText - Text for the confirm button.
 * @param {string} cancelButtonText - Text for the cancel button.
 */
const showAlert = async (title, text, confirmButtonText, cancelButtonText) => {
  const result = await Swal.fire({
    iconHtml: '<img src="' + warning + '">',
    title: title || 'توجه',
    text: text || 'آیا مطمئن هستید؟',
    showCancelButton: true,
    confirmButtonText: confirmButtonText || 'بله',
    cancelButtonText: cancelButtonText || 'خیر',
    padding: '2em',
    reverseButtons: true,
    customClass: {
      popup: 'bg-white dark:bg-slate-700 p-4 !flex flex-col gap-6 justify-center items-center !z-[1000]',
      icon: 'm-0 border-0',
      actions: 'm-0',
      title: '!p-0 !text-base dark:text-slate-300 !leading-8 font-iransansEnNum',
      htmlContainer: '!text-warning-500 !p-0',
      confirmButton: '!bg-success-500',
      cancelButton: '!bg-danger-500'
    }
  });
  return result.isConfirmed;
};

export default showAlert;
